<template>
  <v-bottom-sheet 
    v-model="dialog"
    :content-class="'sub_genres_wrap'"
    persistent
    :transition="false"
  >
    <v-sheet 
      class="text-left subGenresDialog"
      :style="{ transform: `translateY(${sheetTransform}px)`, transition: isDragging ? 'none' : 'transform 0.3s ease' }"
    >
      <div class="style_dialog" 
           @click.stop
           @touchstart.passive="handleTouchStart"
           @touchmove.passive="handleTouchMove"
           @touchend.passive="handleTouchEnd"
      >
        <div class="sheet-handle"></div>
        <h2 class="header">KEY</h2>
        <div class="subGenresItems key-items">
          <div class="diagram-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="332" height="308" viewBox="0 0 332 308" fill="none">
              <path id="path_9b" @click="select('path_9b')" d="M12.2384 112.518C-2.95873 138.525 -3.19351 170.956 11.879 197.035L61.3301 182.579C58.8327 173.482 57.499 163.904 57.499 154.015C57.499 144.177 58.8191 134.646 61.292 125.591L12.2384 112.518Z" fill="#C2AEFB"/>
              <path id="path_10b" @click="select('path_10b')" d="M89.1168 77.8024L53.283 42.2778L12.2384 112.518L61.292 125.591C66.3008 107.249 76.0392 90.8568 89.1168 77.8024Z" fill="#BFCCFF"/>
              <path id="path_11b" @click="select('path_11b')" d="M123.429 0.633484C94.9579 0.769544 68.6762 15.9354 54.3115 40.5178L53.283 42.2778L89.1168 77.8024C102.23 64.7124 118.701 54.9786 137.128 50.0011L123.429 0.633484Z" fill="#B3EEFF"/>
              <path id="path_12b" @click="select('path_12b')" d="M207.462 0.231912L123.429 0.633484L137.128 50.0011C146.124 47.5712 155.586 46.2748 165.35 46.2748C175.249 46.2748 184.835 47.6068 193.941 50.1012L207.462 0.231912Z" fill="#AEFFFC"/>
              <path id="path_1b" @click="select('path_1b')" d="M280.424 42.2778C265.408 16.2959 237.471 0.0885008 207.462 0.231912L193.941 50.1012C212.612 55.2162 229.26 65.2188 242.42 78.6464L280.424 42.2778Z" fill="#B4FFE9"/>
              <path id="path_2b" @click="select('path_2b')" d="M321.019 112.518L280.424 42.2778L242.42 78.6464C255.176 91.6618 264.655 107.895 269.523 126.014L321.019 112.518Z" fill="#BFFFC9"/>
              <path id="path_3b" @click="select('path_3b')" d="M321.019 193.331C335.536 168.487 335.417 137.431 321.019 112.518L269.523 126.014C271.922 134.943 273.202 144.33 273.202 154.015C273.202 163.1 272.076 171.921 269.957 180.349L321.019 193.331Z" fill="#CCFCAE"/>
              <path id="path_4b" @click="select('path_4b')" d="M277.809 267.276L321.019 193.331L269.957 180.349C265.096 199.68 255.006 216.937 241.278 230.532L277.809 267.276Z" fill="#DCEBA7"/>
              <path id="path_5b" @click="select('path_5b')" d="M208.332 307.368C236.951 307.231 263.37 291.986 277.809 267.276L241.278 230.532C228.295 243.389 212.057 252.972 193.909 257.938L207.462 307.372L208.332 307.368Z" fill="#F1CDA7"/>
              <path id="path_6b" @click="select('path_6b')" d="M123.429 307.773L207.462 307.372L193.909 257.938C184.813 260.427 175.237 261.756 165.35 261.756C155.637 261.756 146.224 260.473 137.272 258.068L123.429 307.773Z" fill="#FFAEB7"/>
              <path id="path_7b" @click="select('path_7b')" d="M52.4742 267.276C67.0287 292.459 94.343 307.912 123.429 307.773L137.272 258.068C118.898 253.132 102.464 243.47 89.3554 230.465L52.4742 267.276Z" fill="#F6A2CB"/>
              <path id="path_8b" @click="select('path_8b')" d="M11.879 197.035L52.4742 267.276L89.3554 230.465C76.1908 217.405 66.3806 200.975 61.3301 182.579L11.879 197.035Z" fill="#EAAEEF"/>
              <path id="path_8a" @click="select('path_8a')" d="M130.873 189.027C124.654 182.78 120.106 174.871 117.956 166.025L61.3301 182.579C66.3806 200.975 76.1908 217.405 89.3554 230.465L130.873 189.027Z" fill="#EAAEEF"/>
              <path id="path_9a" @click="select('path_9a')" d="M116.57 154.396C116.57 149.689 117.232 145.138 118.47 140.828L61.292 125.591C58.8191 134.646 57.499 144.177 57.499 154.015C57.499 163.904 58.8327 173.482 61.3301 182.579L117.956 166.025C117.05 162.297 116.57 158.402 116.57 154.396Z" fill="#C2AEFB"/>
              <path id="path_10a" @click="select('path_10a')" d="M89.1168 77.8024C76.0392 90.8568 66.3008 107.249 61.292 125.591L118.47 140.828C120.823 132.633 125.254 125.315 131.158 119.481L89.1168 77.8024Z" fill="#BFCCFF"/>
              <path id="path_11a" @click="select('path_11a')" d="M137.128 50.0011C118.701 54.9786 102.23 64.7124 89.1168 77.8024L131.158 119.481C137.123 113.586 144.59 109.206 152.935 106.965L137.128 50.0011Z" fill="#B3EEFF"/>
              <path id="path_12a" @click="select('path_12a')" d="M165.731 105.285C170.156 105.285 174.445 105.869 178.523 106.964L193.941 50.1012C184.835 47.6068 175.249 46.2748 165.35 46.2748C155.586 46.2748 146.124 47.5712 137.128 50.0011L152.935 106.965C157.015 105.869 161.305 105.285 165.731 105.285Z" fill="#AEFFFC"/>
              <path id="path_1a" @click="select('path_1a')" d="M242.42 78.6464C229.26 65.2188 212.612 55.2162 193.941 50.1012L178.523 106.964C186.743 109.17 194.111 113.452 200.031 119.212L242.42 78.6464Z" fill="#B4FFE9"/>
              <path id="path_2a" @click="select('path_2a')" d="M269.523 126.014C264.655 107.895 255.176 91.6618 242.42 78.6464L200.031 119.212C206.072 125.09 210.604 132.507 212.994 140.829L269.523 126.014Z" fill="#BFFFC9"/>
              <path id="path_3a" @click="select('path_3a')" d="M214.893 154.396C214.893 158.393 214.415 162.279 213.513 165.999L269.957 180.349C272.076 171.921 273.202 163.1 273.202 154.015C273.202 144.33 271.922 134.943 269.523 126.014L212.994 140.829C214.231 145.138 214.893 149.69 214.893 154.396Z" fill="#CCFCAE"/>
              <path id="path_4a" @click="select('path_4a')" d="M241.278 230.532C255.006 216.937 265.096 199.68 269.957 180.349L213.513 165.999C211.333 174.993 206.674 183.019 200.3 189.316L241.278 230.532Z" fill="#DCEBA7"/>
              <path id="path_5a" @click="select('path_5a')" d="M193.909 257.938C212.057 252.972 228.295 243.389 241.278 230.532L200.3 189.316C194.335 195.209 186.869 199.587 178.526 201.828L193.909 257.938Z" fill="#F1CDA7"/>
              <path id="path_6a" @click="select('path_6a')" d="M165.35 261.756C175.237 261.756 184.813 260.427 193.909 257.938L178.526 201.828C174.446 202.923 170.157 203.507 165.731 203.507C161.305 203.507 157.014 202.923 152.934 201.827L137.272 258.068C146.224 260.473 155.637 261.756 165.35 261.756Z" fill="#FFAEB7"/>
              <path id="path_7a" @click="select('path_7a')" d="M89.3554 230.465C102.464 243.47 118.898 253.132 137.272 258.068L152.934 201.827C144.456 199.55 136.884 195.065 130.873 189.027L89.3554 230.465Z" fill="#F6A2CB"/>
              <path d="M54.7432 40.7701C68.9544 16.4502 94.9023 1.40451 123.05 1.13621L136.512 49.6496L136.512 49.6508C118.36 54.6453 102.116 64.2391 89.1164 77.0979L89.1156 77.0971L53.9102 42.1955L54.7432 40.7701ZM89.8266 77.802C102.707 65.0638 118.799 55.5613 136.779 50.6144L152.319 106.615C144.248 108.871 137.008 113.113 131.16 118.779L89.8266 77.802ZM165.731 104.785C161.434 104.785 157.263 105.33 153.285 106.356L137.745 50.3536C146.553 48.019 155.806 46.7748 165.35 46.7748C175.029 46.7748 184.408 48.0542 193.327 50.4528L178.171 106.354C174.195 105.329 170.027 104.785 165.731 104.785ZM200.032 118.519C194.23 112.981 187.086 108.834 179.137 106.613L194.292 50.717C212.513 55.8008 228.779 65.5669 241.708 78.6358L200.032 118.519ZM200.749 119.217L242.408 79.35C254.818 92.1285 264.07 107.983 268.909 125.658L213.337 140.222C210.94 132.175 206.554 124.983 200.749 119.217ZM165.731 204.007C170.028 204.007 174.197 203.462 178.174 202.437L193.294 257.586C184.385 259.979 175.017 261.256 165.35 261.256C155.858 261.256 146.654 260.025 137.889 257.715L153.283 202.436C157.262 203.462 161.433 204.007 165.731 204.007ZM165.35 262.256C175.107 262.256 184.564 260.967 193.559 258.551L193.559 258.552L206.807 306.875L124.089 307.27L137.62 258.679L137.621 258.678C146.472 261.012 155.766 262.256 165.35 262.256ZM207.843 306.87L194.523 258.288L194.523 258.287C212.397 253.307 228.407 243.865 241.274 231.238L241.275 231.239L277.183 267.355C262.791 291.717 236.644 306.732 208.329 306.868L207.843 306.87ZM136.655 258.42L123.049 307.274C94.4092 307.278 67.5476 292.078 53.1 267.358L89.3565 231.171L89.3573 231.17C102.351 243.943 118.557 253.466 136.655 258.419L136.655 258.42ZM88.6466 230.466L52.5815 266.462L12.6305 197.336L60.9825 183.201L60.9837 183.201C66.0504 201.32 75.7176 217.52 88.6474 230.466L88.6466 230.466ZM60.7177 182.237L12.1164 196.445C-2.6044 170.691 -2.37369 138.784 12.4787 113.099L60.6772 125.944L60.6783 125.945C58.2785 134.897 56.999 144.307 56.999 154.015C56.999 163.777 58.2929 173.238 60.7188 182.236L60.7177 182.237ZM60.9406 124.98L13.0011 112.204L53.3892 43.0872L88.4079 77.8036L88.4087 77.8044C75.563 90.7461 65.9658 106.912 60.9417 124.98L60.9406 124.98ZM61.9081 125.237C66.8861 107.342 76.393 91.3292 89.1189 78.5085L130.449 119.482C124.777 125.203 120.488 132.296 118.127 140.22L61.9081 125.237ZM61.6446 126.202L117.851 141.181C116.69 145.389 116.07 149.82 116.07 154.396C116.07 158.276 116.516 162.053 117.359 165.678L61.6788 181.956C59.2791 173.048 57.999 163.681 57.999 154.015C57.999 144.395 59.2669 135.072 61.6446 126.202ZM61.9436 182.92L117.596 166.651C119.775 175.216 124.184 182.892 130.168 189.024L89.3552 229.759C76.541 216.929 66.9621 200.875 61.9436 182.92ZM90.0651 230.463L130.874 189.733C136.771 195.539 144.115 199.883 152.318 202.176L136.923 257.455C118.995 252.55 102.94 243.117 90.0651 230.463ZM137.477 49.3889L124.086 1.13035L206.807 0.735045L193.589 49.4865L193.589 49.4876C184.585 47.0662 175.118 45.7748 165.35 45.7748C155.714 45.7748 146.372 47.0315 137.477 49.39L137.477 49.3889ZM194.554 49.7507L207.845 0.730969C237.397 0.726551 264.884 16.6681 279.794 42.1887L242.431 77.9435L242.431 77.9443C229.379 64.7471 212.954 54.8844 194.554 49.7518L194.554 49.7507ZM243.131 78.6578L280.309 43.0793L320.258 112.201L269.877 125.404L269.876 125.405C264.993 107.561 255.655 91.5568 243.131 78.6586L243.131 78.6578ZM270.137 126.37L320.776 113.099C334.834 137.693 334.948 168.231 320.776 192.753L270.563 179.987L270.562 179.987C272.614 171.666 273.702 162.967 273.702 154.015C273.702 144.461 272.463 135.196 270.136 126.37L270.137 126.37ZM320.252 193.652L277.705 266.462L241.986 230.535L241.985 230.534C255.481 217.046 265.431 200.015 270.318 180.957L270.32 180.957L320.252 193.652ZM269.593 179.741L214.113 165.636C214.951 162.024 215.393 158.261 215.393 154.396C215.393 149.821 214.774 145.391 213.613 141.184L269.168 126.624C271.474 135.367 272.702 144.547 272.702 154.015C272.702 162.883 271.624 171.5 269.593 179.741ZM213.878 166.608L269.349 180.711C264.508 199.589 254.651 216.461 241.28 229.825L201.006 189.318C207.147 183.127 211.668 175.328 213.878 166.608ZM179.14 202.178C187.209 199.923 194.447 195.683 200.295 190.02L240.569 230.529C227.821 243.036 211.962 252.389 194.259 257.323L179.14 202.178Z" stroke="#101929"/>
            </svg>

            <span class="a1 key-lbl" @click="select('path_1a')">1a</span>
            <span class="a2 key-lbl" @click="select('path_2a')">2a</span>
            <span class="a3 key-lbl" @click="select('path_3a')">3a</span>
            <span class="a4 key-lbl" @click="select('path_4a')">4a</span>
            <span class="a5 key-lbl" @click="select('path_5a')">5a</span>
            <span class="a6 key-lbl" @click="select('path_6a')">6a</span>
            <span class="a7 key-lbl" @click="select('path_7a')">7a</span>
            <span class="a8 key-lbl" @click="select('path_8a')">8a</span>
            <span class="a9 key-lbl" @click="select('path_9a')">9a</span>
            <span class="a10 key-lbl" @click="select('path_10a')">10a</span>
            <span class="a11 key-lbl" @click="select('path_11a')">11a</span>
            <span class="a12 key-lbl" @click="select('path_12a')">12a</span>
            <span class="b1 key-lbl" @click="select('path_1b')">1b</span>
            <span class="b2 key-lbl" @click="select('path_2b')">2b</span>
            <span class="b3 key-lbl" @click="select('path_3b')">3b</span>
            <span class="b4 key-lbl" @click="select('path_4b')">4b</span>
            <span class="b5 key-lbl" @click="select('path_5b')">5b</span>
            <span class="b6 key-lbl" @click="select('path_6b')">6b</span>
            <span class="b7 key-lbl" @click="select('path_7b')">7b</span>
            <span class="b8 key-lbl" @click="select('path_8b')">8b</span>
            <span class="b9 key-lbl" @click="select('path_9b')">9b</span>
            <span class="b10 key-lbl" @click="select('path_10b')">10b</span>
            <span class="b11 key-lbl" @click="select('path_11b')">11b</span>
            <span class="b12 key-lbl" @click="select('path_12b')">12b</span>
          </div>
        </div>

        <div class="modal_wrap_actions">
          <button type="button" class="unsubscribe" v-ripple @click="clear">Clear</button>
          <button type="button" class="keep_it" v-ripple @click="apply" style="background: #5F6986;">Apply</button>
        </div>
      </div>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

const KEYS_MAP = {
  path_1b: { id: 1, code: '1b'},
  path_2b: { id: 2, code: '2b'},
  path_3b: { id: 3, code: '3b'},
  path_4b: { id: 4, code: '4b'},
  path_5b: { id: 5, code: '5b'},
  path_6b: { id: 6, code: '6b'},
  path_7b: { id: 7, code: '7b'},
  path_8b: { id: 8, code: '8b'},
  path_9b: { id: 9, code: '9b'},
  path_10b: { id: 10, code: '10b'},
  path_11b: { id: 11, code: '11b'},
  path_12b: { id: 12, code: '12b'},
  path_1a: { id: 13, code: '1a'},
  path_2a: { id: 14, code: '2a'},
  path_3a: { id: 15, code: '3a'},
  path_4a: { id: 16, code: '4a'},
  path_5a: { id: 17, code: '5a'},
  path_6a: { id: 18, code: '6a'},
  path_7a: { id: 19, code: '7a'},
  path_8a: { id: 20, code: '8a'},
  path_9a: { id: 21, code: '9a'},
  path_10a: { id: 22, code: '10a'},
  path_11a: { id: 23, code: '11a'},
  path_12a: { id: 24, code: '12a'},
}


export default {
  name: 'KeyFilterCard',
  props: ['filterName', 'value'],
  data() {
    return {
      localKeys: [],
      selectedPaths: {},
      isCleared: false,
      touchStartY: 0,
      sheetTransform: 0,
      isDragging: false,
      initialSheetHeight: 0
    };
  },
  computed: {
    ...mapGetters(['SONG_KEYS', 'KEYS', 'APPLY_KEYS']),
    dialog: {
      get() { return this.value; },
      set(value) { this.$emit('input', value); }
    }
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.initializeKeys();
        this.resetSheet();
        // Smooth scroll to top when opening
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    APPLY_KEYS: {
      handler(newVal) {
        if (this.dialog && !this.isCleared) {
          this.localKeys = JSON.parse(JSON.stringify(newVal));
          this.updateVisualSelection();
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['GET_SONG_KEYS', 'UPDATE_KEYS']),
    ...mapMutations(['SET_APPLY_KEYS']),

    initializeKeys() {
      this.localKeys = JSON.parse(JSON.stringify(this.APPLY_KEYS));
      this.updateVisualSelection();
      this.isCleared = false;
    },

    updateVisualSelection() {
      document.querySelectorAll('.active-key').forEach(el => el.classList.remove('active-key'));
      this.selectedPaths = {};
      this.localKeys.forEach(key => {
        const pathId = Object.keys(KEYS_MAP).find(k => KEYS_MAP[k].id === key.id);
        if (pathId) {
          const pathElement = document.getElementById(pathId);
          if (pathElement) {
            pathElement.classList.add('active-key');
            this.$set(this.selectedPaths, pathId, pathElement);
          }
        }
      });
    },

    select(pathId) {
      const keyProperty = KEYS_MAP[pathId];
      const index = this.localKeys.findIndex(item => item.id === keyProperty.id);
      if (index !== -1) {
        this.localKeys.splice(index, 1);
      } else {
        this.localKeys.push({ id: keyProperty.id, code: keyProperty.code });
      }
      this.updateVisualSelection();
    },

    apply() {
      this.UPDATE_KEYS(this.localKeys);
      this.SET_APPLY_KEYS(this.localKeys);
      this.$emit('keys-applied', this.localKeys);
      this.dialog = false;
      this.isCleared = false;
    },

    clear() {
      this.localKeys = [];
      this.updateVisualSelection();
      this.UPDATE_KEYS([]);
      this.SET_APPLY_KEYS([]);
      this.$emit('keys-applied', []);
      this.dialog = false;
      this.isCleared = true;
    },

    handleTouchStart(e) {
      if (e.target.closest('button') || e.target.closest('.subGenresItems')) {
        return;
      }
      
      const sheet = e.target.closest('.style_dialog');
      if (sheet) {
        this.initialSheetHeight = sheet.getBoundingClientRect().height;
      }
      
      this.isDragging = true;
      this.touchStartY = e.touches[0].clientY;
      this.sheetTransform = 0;
    },

    handleTouchMove(e) {
      if (!this.isDragging) return;
      
      const currentY = e.touches[0].clientY;
      const deltaY = currentY - this.touchStartY;
      
      if (deltaY > 0) {
        const resistance = 0.7;
        const resistedDelta = deltaY * resistance;
        this.sheetTransform = resistedDelta;
      }
    },

    handleTouchEnd() {
      if (!this.isDragging) return;
      
      const threshold = this.initialSheetHeight * 0.2;
      const velocity = Math.abs(this.sheetTransform / 16);
      
      if (this.sheetTransform > threshold || velocity > 10) {
        this.dialog = false;
      } else {
        requestAnimationFrame(() => {
          this.sheetTransform = 0;
        });
      }
      
      this.isDragging = false;
    },

    resetSheet() {
      this.sheetTransform = 0;
      this.isDragging = false;
      this.initialSheetHeight = 0;
    }
  }
};
</script>

<style scoped>
.subGenresDialog {
  height: 100% !important;
  min-height: 600px !important;
  display: flex;
  flex-direction: column;
  will-change: transform;
  transform-origin: bottom;
  touch-action: pan-x pan-y;
}

.style_dialog {
  background-color: #1A1F34;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
  position: relative;
  padding-top: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  touch-action: pan-x pan-y;
}

.style_dialog .header {
  color: #FFF;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro Display", system-ui;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  text-align: center;
  padding: 18px;
  background: none;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.key-items {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  flex: 1;
}

.key-items button {
    border: 1px solid #5F6986;
    border-radius: 12px;
    /* padding: 11px 15px; */
    /* margin: 5px 0; */
}

.key-items button.active {
  background-color: #5F6986;
}

.key-lbl {
  color: #000;
}

.active-key {
  opacity: 0.5;
}
path {
  opacity: 1;
}
.diagram-wrap svg {
  width: 100%;
  height: auto;
}

.diagram-wrap span {
  position: absolute;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.24px;
  text-transform: uppercase;
}

.diagram-wrap span[ class ^= "b" ] {
  font-weight: bold;
}

.diagram-wrap .a1 {
  left: 60%;
  top: 22%;
}
.diagram-wrap .a2 {
  left: 69%;
  top: 32%;
}
.diagram-wrap .a3 {
  left: 72%;
  top: 46%;
}
.diagram-wrap .a4 {
  left: 69%;
  top: 59%;
}
.diagram-wrap .a5 {
  left: 60%;
  top: 69%;
}
.diagram-wrap .a6 {
  left: 47%;
  top: 73%;
}
.diagram-wrap .a7 {
  left: 35%;
  top: 69%;
}
.diagram-wrap .a8 {
  left: 25%;
  top: 59%;
}
.diagram-wrap .a9 {
  left: 21%;
  top: 45%;
}
.diagram-wrap .a10 {
  left: 24%;
  top: 32%;
}
.diagram-wrap .a11 {
  left: 33%;
  top: 21%;
}
.diagram-wrap .a12 {
  left: 46%;
  top: 17%;
}
.diagram-wrap .b1 {
  left: 68%;
  top: 8%;
}
.diagram-wrap .b2 {
  left: 82%;
  top: 25%;
}
.diagram-wrap .b3 {
  left: 91%;
  top: 46%;
}
.diagram-wrap .b4 {
  left: 82%;
  top: 67%;
}
.diagram-wrap .b5 {
  left: 68%;
  top: 84%;
}
.diagram-wrap .b6 {
  left: 48%;
  top: 88%;
}
.diagram-wrap .b7 {
  left: 28%;
  top: 84%;
}
.diagram-wrap .b8 {
  left: 14%;
  top: 68%;
}
.diagram-wrap .b9 {
  left: 3%;
  top: 47%;
}
.diagram-wrap .b10 {
  left: 12%;
  top: 26%;
}
.diagram-wrap .b11 {
  left: 26%;
  top: 9%;
}
.diagram-wrap .b12 {
  left: 46%;
  top: 3%;
}

.diagram-wrap {
  background-color: #1A1F34;
  position: relative;
  width: fit-content;
}

.modal_wrap_actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin: 0;
}

.modal_wrap_actions > button {
    display: flex;
    padding: 16px 0px;
    gap: 10px;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid var(--icon-purple, #5F6986);
    width: 156px;
    justify-content: center;
    height: 48px;
}

.sheet-handle {
  width: 32px;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
}

:deep(.v-dialog_content),
:deep(.v-overlay__content) {
  transition: none !important;
}

:deep(.v-overlay__scrim) {
  transition: none !important;
}
</style>
